import { useState } from "react";
import { toast } from "sonner";
import { Plus, Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { DateInput } from "@/components/DateInput";
import api from "@/lib/api";
import { euro, formatApiErrorDetail } from "@/lib/format";
import { todayIso, fmtDay } from "@/lib/cantieri";

export const AccontiPanel = ({ cantiere, onChanged }) => {
  const [f, setF] = useState({ data: todayIso(), importo: "", metodo: "Bonifico", note: "" });
  const [busy, setBusy] = useState(false);
  const add = async () => {
    setBusy(true);
    try {
      const r = await api.post(`/cantieri/${cantiere.id}/acconti`, { ...f, importo: Number(f.importo) });
      toast.success("Acconto registrato");
      setF({ ...f, importo: "", note: "" }); onChanged(r.data);
    } catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail)); }
    finally { setBusy(false); }
  };
  const del = async (id) => onChanged((await api.delete(`/cantieri/${cantiere.id}/acconti/${id}`)).data);
  return (
    <div className="space-y-4" data-testid="acconti-panel">
      <div className="grid grid-cols-2 sm:grid-cols-[150px_130px_1fr_auto] gap-2 items-end rounded-xl border border-border p-3">
        <DateInput value={f.data} onChange={(e) => setF({ ...f, data: e.target.value })} data-testid="acconto-date-input" />
        <Input type="number" min="0" step="0.01" placeholder="Importo €" value={f.importo} onChange={(e) => setF({ ...f, importo: e.target.value })} data-testid="acconto-amount-input" />
        <Input placeholder="Metodo / note (es. bonifico)" value={f.metodo} onChange={(e) => setF({ ...f, metodo: e.target.value })} className="col-span-2 sm:col-span-1" data-testid="acconto-method-input" />
        <Button onClick={add} disabled={busy || !(Number(f.importo) > 0)} className="col-span-2 sm:col-span-1" data-testid="acconto-add-button"><Plus className="w-4 h-4 mr-1" /> Aggiungi</Button>
      </div>
      <div className="rounded-xl border border-border divide-y divide-border">
        {(cantiere.acconti || []).map((a) => (
          <div key={a.id} className="flex items-center gap-3 px-4 py-2.5 text-sm group" data-testid={`acconto-row-${a.id}`}>
            <span className="w-24 text-muted-foreground">{fmtDay(a.data)}</span>
            <span className="flex-1 truncate">{a.metodo}{a.note ? ` · ${a.note}` : ""}</span>
            <span className="font-semibold">{euro(a.importo)}</span>
            <Button variant="ghost" size="icon" className="h-7 w-7 text-muted-foreground hover:text-destructive" onClick={() => del(a.id)} data-testid={`acconto-delete-${a.id}`}><Trash2 className="w-3.5 h-3.5" /></Button>
          </div>
        ))}
        {!cantiere.acconti?.length && <div className="p-6 text-center text-sm text-muted-foreground">Nessun acconto ricevuto.</div>}
      </div>
    </div>
  );
};

export default AccontiPanel;
